<div class="{{contentClass}}">
	<h2 mat-dialog-title class="{{ style }}">{{ dialogData.title }}</h2>
	<div mat-dialog-content>
		<p>{{ dialogData.message }}</p>
	</div>
	<div mat-dialog-actions class="text-center mb-0">
		<button mat-flat-button color="primary" class="responsive-button" (click)="save()">
			<span [hidden]="dialogData.okButton" i18n="ok or confirm button title">Ok</span>
			<span [hidden]="!dialogData.okButton">{{ dialogData.okButton }}</span>
		</button>
	</div>
</div>
